import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import isMatch from 'lodash/isMatch';
import pick from 'lodash/pick';

import { getShop, getBarberUserId, getActiveShopBrandId } from '../../../../auth/selectors';
import { fetchBrandItems } from '../../../../products/categories/actions';

const mapStateToProps = state => ({
  shop: getShop(state),
  barberUserId: getBarberUserId(state),
  brandId: getActiveShopBrandId(state),
});

export default compose(
  connect(mapStateToProps, { fetchBrandItems }),
  withHandlers({
    loadData: props => () => props.fetchBrandItems(props.brandId),
  }),
  lifecycle({
    componentDidMount() {
      this.props.loadData();
    },
    componentDidUpdate(prevProps) {
      const propsToTrack = ['brandId', 'barberUserId', 'shop'];
      if (!isMatch(pick(this.props, propsToTrack), pick(prevProps, propsToTrack))) {
        this.props.loadData();
      }
    },
  })
);
